import { render, staticRenderFns } from "./x-form.vue?vue&type=template&id=154c16dc&"
import script from "./x-form.vue?vue&type=script&lang=js&"
export * from "./x-form.vue?vue&type=script&lang=js&"
import style0 from "./x-form.vue?vue&type=style&index=0&id=154c16dc&prod&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports